import { useParams } from 'react-router-dom';

import { UiWithReleaseOrDraftProcessId } from 'app/routes/uiPathParams';
import { hasAutomatedIndexingLicense } from 'container/services/automatedIndexing/AutomatedIndexingRepo';
import { useGetProcessDraft } from 'features/draft/useGetProcessDraft';
import { hasGeneralPayablesLicense } from 'features/generalPayables/config';
import { hasMaintenancePayablesLicense } from 'features/maintenancePayables/config';
import { hasOrderEntryLicense } from 'features/orderEntry/config';

import { LicensedModule } from './typing';

export function useLicensing() {
  const { releaseOrDraftProcessId, draftProcessId } =
    useParams<UiWithReleaseOrDraftProcessId>();
  const { draft, isDraftLoading } = useGetProcessDraft(
    draftProcessId ?? releaseOrDraftProcessId
  );

  const hasLicense = (module: LicensedModule) => {
    switch (module) {
      case LicensedModule.AUTOMATED_INDEXING:
        return hasAutomatedIndexingLicense(draft);

      case LicensedModule.ORDER_ENTRY:
        return hasOrderEntryLicense(draft);

      case LicensedModule.MAINTENANCE_PAYABLES:
        return hasMaintenancePayablesLicense(draft);

      case LicensedModule.GENERAL_PAYABLES:
        return hasGeneralPayablesLicense(draft);

      default:
        return false;
    }
  };
  return {
    isLoading: isDraftLoading,
    hasLicense,
  };
}
